// TODO: The purpose of this file should be clarified. Why do we need to keep copies of the player
// instances on the page?

export const globalState = {
  players: [],
  videoData: [],
};

/**
 * Add jwplayer to globalState
 *
 * @param {object} player - jwplayer.
 * @param {object} config - Config passed to jwplayer.
 * @param {boolean} isTop - Is top video of page.
 * @returns {void}
 */
export const addPlayerToState = (player, config, mediaId, isTop = false) => {
  globalState.players.push({ player, config, mediaId, isTop });
};

/**
 * Get player from globalState for eq. modify config.
 *
 * @param {object} player - jwplayer.
 * @returns {object}
 */
export const getPlayerFromState = (player) =>
  globalState.players.find((p) => p.player.getConfig().id === player.getConfig().id);

/**
 * Get video data from globalState
 *
 * @returns {array}
 */
export const getVideoData = () => globalState.videoData;

/**
 * Set video data to globalState
 *
 * @param {array} data - video data
 * @returns {object}
 */
export const setVideoData = (data = []) => (globalState.videoData = data);
